import Vue from 'vue'
import App from './App.vue'

import store from './store'
import helper from './assets/function.js'
import directive from './assets/directive.js'



/********************/
/* 	  DIRECTIVES 	*/
/********************/
Vue.use(directive);
Vue.directive('date_format', directive.date_format);
Vue.directive('value_format', directive.value_format);






/********************/
/* 	  HELPER 	*/
/********************/
const plugin = {
	install(){
		Vue.helper = helper;
		Vue.prototype.$helper = helper;
	}
}

Vue.use(plugin)




/**
 * Number.prototype.format(n, x, s, c)
 * 
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
Number.prototype.format = function(n, x, s, c) {
	var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
		num = this.toFixed(Math.max(0, ~~n));

	return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};




Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  render: h => h(App)
}).$mount('#app')
